/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSquareBracketCurlyLeft: {
  name: 'square-bracket-curly-left';
  data: string;
} = {
  name: 'square-bracket-curly-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm0 2h14v14H5V5Zm8 2a2 2 0 0 0-2 2v1.382l-1.447.724a1 1 0 0 0 0 1.788l1.447.724V15a2 2 0 0 0 2 2h1a1 1 0 1 0 0-2h-1v-1.382A2 2 0 0 0 12.176 12 2 2 0 0 0 13 10.382V9h1a1 1 0 1 0 0-2h-1Z" fill="currentColor"/></svg>`,
};
